<div class="btn-group" dropdown [isAnimated]="true" [insideClick]="true">
  @if (userAvatar()) {
    <p-button size="large" [outlined]="true" dropdownToggle>
      <div class="py-0.5 flex items-center">
        <afra-image [fileId]="userAvatar()" class="avatar"></afra-image>
      </div>
    </p-button>
  } @else {
    <p-button
      size="large"
      [outlined]="true"
      dropdownToggle
      icon="pi pi-user"
    ></p-button>
  }

  <!-- <button id="button" dropdownToggle variant="outlined" pButton></button> -->
  <div
    *dropdownMenu
    class="dropdown-menu p-3"
    aria-labelledby="button"
    role="menu"
    style="min-width: 265px"
  >
    <div class="d-flex align-items-center">
      <afra-image
        *ngIf="profile?.profileAvatar; else defaultAvatarMenu"
        [fileId]="profile?.profileAvatar"
        alt="avatar"
        class="dx-icon avatar shrink-0"
        style="width: 20px"
      ></afra-image>
      <ng-template #defaultAvatarMenu>
        <ng-icon
          name="lucideUser"
          class="dx-icon text-black shrink-0"
          *ngIf="!profile?.profileAvatar"
        ></ng-icon>
      </ng-template>
      <div class="grow w-0 ms-2">
        <span class="text-black me-2 mb-1">{{ profile?.fullName }}</span>
        <span class="badge badge-pill whitespace-pre-wrap! bg-secondary">{{
          profile?.defaultPositions
        }}</span>
      </div>
    </div>
    <div class="border-t border-gray-200 mt-2 pt-2 d-flex align-items-center">
      <ng-icon name="lucideBuilding" class="text-muted fs-4 me-2"></ng-icon>
      <span>{{ profile?.charityTitle }}</span>
    </div>
    <div class="mt-2 d-flex align-items-center">
      <ng-icon name="lucidePhone" class="text-muted fs-5 me-2"></ng-icon>
      <span>{{ profile?.mobileNumber }}</span>
    </div>
    <div class="mt-2 d-flex align-items-center">
      <ng-icon name="lucideHandshake" class="text-muted fs-4 me-2"></ng-icon>
      <span>{{ profile?.defaultCooperationType }}</span>
    </div>
    <div class="border-t border-gray-200 mt-2 pt-2">
      <a href="/profile/edit">
        <button class="btn btn-link text-decoration-none text-success ps-0">
          <ng-icon name="lucidePen" class="fs-5 me-2"></ng-icon>
          <span>{{ "homePage.labels.edit" | translate }}</span>
        </button>
      </a>
      <!-- logoff buttton -->
      <br />
      <button
        class="btn btn-link text-decoration-none text-success ms-auto ps-0"
        (click)="logOff()"
      >
        <ng-icon name="lucideLogOut" class="fs-5 me-2"></ng-icon>
        <span>{{ "homePage.labels.logoff" | translate }}</span>
      </button>
    </div>
    <!-- Add more dropdown items here if needed -->
  </div>
</div>
